import { RouterProvider } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import { HeroUIProvider } from '@heroui/react'
import { Toaster } from 'sonner'
import { router } from './router'
import { queryClient } from './lib/query/query-client'
import { ThemeProvider } from './components/ThemeProvider'

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <HeroUIProvider>
        <ThemeProvider>
          <RouterProvider router={router} />
          <Toaster richColors position="top-right" />
        </ThemeProvider>
      </HeroUIProvider>
    </QueryClientProvider>
  )
}
